import {PurchaseOrderItem, SourceMode, ToSourceItem} from "../../../../api/Logistics";
import {PhaseViewCol} from "../../../project/shopdrawing/openings/PhaseCol";
import {NumberCol, PrefixSearch, StringCol, Table, ViewOnly} from "../../../../misc/scroller/Table";
import {hasPermission, useUser} from "../../../../misc/Permission";
import {api} from "../../../../api/API";
import {ProjectCol, toSourceTableName} from "../PartsToSource";
import {useContext, useMemo} from "react";
import {CheckboxSelectorCol} from "../../../project/shopdrawing/Checkbox";
import {formatDescription} from "./SubmitButton";
import {firstValue} from "../FindValues";
import {DistributionMode} from "../DistributionModeToggle";
import {useActionCol} from "./ActionCol";
import {getAll} from "../../routes/useGetAll";
import {DropDownContext, useDropdownData} from "../../../project/settings/DropDowns";
import {DateFilterCol} from "../../../../misc/DateFilterForCol";

export function FrameAnchors(props: {
    purchaseOrder?: number;
    supplier?: {
        id: number;
        name: string;
    }
    sourceMode: SourceMode;
    distributionMode: DistributionMode;
}) {
    const usr = useUser();

    const mfg = props.supplier?.id || 0;
    const key = useMemo(() => {
        return props.purchaseOrder + "-" + mfg;
    }, [props.purchaseOrder, mfg])

    const ddl = useContext(DropDownContext);
    const ddlOptions = useDropdownData(ddl.root);

    const supplier: any = [];
    if(!props.supplier) {
        supplier.push(ViewOnly(StringCol<ToSourceItem>("Supplier", "supplierName", 200)));
    }

    const isRestock = props.sourceMode === "stock"

    const actionCol = useActionCol({
        purchaseOrder: props.purchaseOrder,
        sourceMode: props.sourceMode,
        update: (input: Partial<PurchaseOrderItem>, dt: ToSourceItem) => {
            return Object.assign({}, input, {
                kind: "frame-anchor",
                description: formatDescription(Object.assign({}, dt, {
                    frameAnchorName: firstValue(dt.frameAnchorDetail || [], d => d.productCode) || "",
                }), {
                    ddlOptions
                }),
            });
        }
    });

    return (
        <Table<ToSourceItem>
            key={key}
            name={toSourceTableName}
            overridePrefsName={toSourceTableName + ".frameAnchors." + props.sourceMode}
            columns={[
                props.purchaseOrder ? CheckboxSelectorCol({
                    disabled: row => !hasPermission(usr, "CanReleaseAndPurchase") && usr?.id === row.releasedBy,
                }) : null,
                !isRestock && ViewOnly(ProjectCol("Project", "projectName", "projectNumber", 100)),
                !isRestock && ViewOnly(StringCol("Opening", "openingName", 100)),
                !isRestock && ViewOnly(StringCol("Floor", "openingFloor", 70)),
                !isRestock && PhaseViewCol<ToSourceItem>("openingPhase", 70),
                DateFilterCol<ToSourceItem>("Due", "neededBy", "MMM D, YYYY", 100, "future"),
                ...supplier,
                ViewOnly(StringCol("Mfg", "manufacturerName", 200)),
                ViewOnly(StringCol("Name", "name", 200)),
                ViewOnly(PrefixSearch(StringCol("Code", "productCode", 100))),
                ViewOnly(StringCol("Dim.", "dimensions", 60)),
                ViewOnly(NumberCol("Need", "qty", 60)),
                isRestock && ViewOnly(NumberCol("Stock", "stockQty", 60)),
                isRestock && ViewOnly(NumberCol("Rsrvd", "reservedQty", 60)),
                isRestock && ViewOnly(NumberCol("Pend.PO", "purchasedQty", 90)),
                isRestock && ViewOnly(NumberCol("Stock Min", "stockMinQty", 90)),
                isRestock && ViewOnly(NumberCol("Ideal Qty", "idealQty", 90)),
                actionCol,
            ]}
            fetch={ctx => getAll(ctx, offset => api.logistics.listToSourceItems({
                offset,
                supplier: props.supplier?.id,
                type: "frame-anchor",
                sourceMode: props.sourceMode,
                distributionMode: props.distributionMode,
            }))}
            fetchDeps={[props.supplier, props.sourceMode, props.distributionMode]}
        />
    )
}